import FormValidatorIndicator from "./formvalidator-indicator";

const formvalidatorIndicator = new FormValidatorIndicator();
export default class ConnectExterrnal {

    sendSmsButtonFirst = document.querySelector('.oc-smscode-button');
    sendSmsButton = document.querySelectorAll('.oc-smscode-button');
    sendSmsButtonReply = document.querySelector('.oc-smscode-button-error');
    recipient = document.querySelector('.oc_sms_phone_number');
    smsCodeInput = document.querySelector('.oc_smscode');

    //inputCode = document.querySelector('.oc_smscode');

    smsCreate(form) {

        let sendSmsButton = form.querySelector('.oc-smscode-button');
        let recipient = form.querySelectorAll('.oc_sms_phone_number');
        let smsCodeInput = form.querySelector('.oc_smscode');

        if (sendSmsButton && recipient.length > 0 && smsCodeInput) {

            // this.createToken(form);
            //this.sendSmsButton.forEach(button => {
            sendSmsButton.addEventListener('click', () => {
                formvalidatorIndicator.correctIndicator(smsCodeInput);
                event.preventDefault();
                this.sendAuthorizedSMS(form);

                //this.sendCheckSMS(form, smsCodeInput);
                if (smsCodeInput.name != '') {

                    smsCodeInput.classList.remove('d-none');
                    smsCodeInput.addEventListener('input', () => {

                        this.sendCheckSMS(form, smsCodeInput);
                        formvalidatorIndicator.correctIndicator(smsCodeInput);

                    });
                }
                smsCodeInput.correct = false;
            });
            //});
        } else {
            if (smsCodeInput) {
                smsCodeInput.correct = false;
                smsCodeInput.frontMessages = "Brak numeru telefonu do komunikacji w celu uwierzytelnienia.";
                formvalidatorIndicator.correctIndicator(smsCodeInput);
            }

        }
    }

    /**
     * Send SMS with code to phone's number added in previous step

     */
    async sendAuthorizedSMS(form) {
        let smsCodeInput = form.querySelector('.oc_smscode');
        let recipient = form.querySelector('.oc_sms_phone_number');
        let sendSmsButtonReply = form.querySelectorAll('.oc-smscode-button-error');
        let smsCode = form.querySelector('.oc_smscode_hidden');

        const token = this.createToken(form);

        if (recipient.value) {
            //smsCodeInput.correct = true;
            smsCodeInput.frontMessages = "";

            /* if (sendSmsButtonReply.length > 0) {
                 sendSmsButtonReply.forEach(element => {
                    element.classList.add('d-none');
                 });
             }*/

            let phone = decodeURIComponent(this.recipient.value.replace(/%[0-9A-F]{2}|[\s]/gi, ''));
            try {
                const data = {};
                const response = await fetch(`/api/sms/${phone}/${token}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                if (response.ok) {
                    const result = await response.json();
                    // console.log('SMS sent:', result);

                    if (result.success) {

                        smsCodeInput.frontMessages = "Wysłano kod autoryzacyjny";
                        // console.log(result.success);
                    } else {
                        smsCodeInput.correct = false;
                        smsCodeInput.frontMessages = result.message;
                        // console.log(result.success);
                        formvalidatorIndicator.correctIndicator(smsCodeInput);

                        /* sendSmsButtonReply.forEach(element => {
                            element.classList.add('d-none');
                         });*/
                    }
                } else {

                    smsCodeInput.correct = false;
                    smsCodeInput.frontMessages = "Sprawdź połączenie z internetem i spróbuj jeszcze raz wysłać kod";
                    formvalidatorIndicator.correctIndicator(smsCodeInput);

                    /* if (sendSmsButtonReply.length > 0) {
                         sendSmsButtonReply.forEach(element => {
                             element.classList.remove('d-none');
                         });
                     }*/
                }
            } catch (error) {
                console.error('An error occurred while sending SMS:', error);
                smsCodeInput.correct = false;
                smsCodeInput.frontMessages = "Problem z połączeniem (2)";

            }
        } else {

            smsCodeInput.correct = false;
            smsCodeInput.frontMessages = "Brak numeru telefonu do komunikacji w celu uwierzytelnienia";
            formvalidatorIndicator.correctIndicator(smsCodeInput);
        }
    }

    async sendCheckSMS(form, input) {
        input.correct = false;
        formvalidatorIndicator.correctIndicator(input);
        const codeValue = input.value;
        let smsCodeInput = form.querySelector('.oc_smscode');
        let recipient = form.querySelector('.oc_sms_phone_number');
        let sendSmsButtonReply = form.querySelectorAll('.oc-smscode-button-error');
        let smsCode = form.querySelector('.oc_smscode_hidden');

        let phone = decodeURIComponent(this.recipient.value.replace(/%[0-9A-F]{2}|[\s]/gi, ''));

        try {
            const response = await fetch(`/api/sms-check/${smsCode.value}/${codeValue}`, {

                method: 'POST', headers: {
                    'Content-Type': 'application/json'
                },
            });
            setTimeout(() => {

            }, 300);
            if (response.ok) {
                const result = await response.json();

                if (result.code === true) {
                    smsCodeInput.correct = true;
                    smsCodeInput.classList.add("validSms");
                    input.correct2Sms = true;
                    smsCodeInput.frontMessages = "Prawidłowy kod sms";
                    //console.log("Kod OK")
                    formvalidatorIndicator.correctIndicator(smsCodeInput);
                    if (sendSmsButtonReply.length > 0) {
                        sendSmsButtonReply.forEach(element => {
                            element.classList.add('d-none');
                        });
                    }

                    //sendSmsButtonReply.classList.add('d-none')
                } else {

                    smsCodeInput.correct = false;
                    smsCodeInput.classList.remove("validSms");
                    smsCodeInput.frontMessages = "Błędny kod sms";
                    formvalidatorIndicator.correctIndicator(smsCodeInput);

                }

            } else {
                // console.log('Failed to send SMS:', response.status);
                smsCodeInput.correct = false;
                input.correct = false;
                formvalidatorIndicator.correctIndicator(smsCodeInput);
                if (codeValue) {
                    smsCodeInput.frontMessages = "Problem z połączeniem (1)";
                } else {
                    smsCodeInput.frontMessages = "Wpisz kod autoryzacyjny";
                }
            }
        } catch (error) {
            console.error('An error occurred while sending SMS:', error);
            smsCodeInput.correct = false;
            input.correct = false;
            smsCodeInput.frontMessages = "Problem z połączeniem (2)";
        }
        // }
    }

    generateRandomCode(length) {
        let code = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZqwertyuiopasdfghjklzxcvbnm0123456789";


        for (let i = 0; i < length; i++) {
            let randomIndex = Math.floor(Math.random() * characters.length);
            code += characters.charAt(randomIndex);
        }

        return code;
    }

    createToken(form) {

        let hiddenInput = form.querySelector('.oc_smscode_hidden');
        let token = this.generateRandomCode(65);

        if (hiddenInput) {
            hiddenInput.value = token;
        } else {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'smsCode';
            hiddenInput.value = token;
            hiddenInput.classList.add('oc_smscode_hidden');
            hiddenInput.classList.add('d-none');
            form.appendChild(hiddenInput);
        }

        hiddenInput.classList.add('d-none');
        return token;
    }
}